/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { type AssistantStep, Steps } from '@/types';

const ASSISTANT_STEPS: Record<Steps, AssistantStep> = {
  [Steps.Identification]: {
    title: 'Identification',
    dataTestId: 'assistant-step-identification',
  },
  [Steps.AdressesContacts]: {
    title: 'Adresses et contacts',
    dataTestId: 'assistant-step-adresses-contacts',
  },
  [Steps.Filiation]: {
    title: 'Filiation',
    dataTestId: 'assistant-step-filiation',
  },
  [Steps.InformationsComplementaires]: {
    title: 'Informations complémentaires',
    dataTestId: 'assistant-step-informations-complementaires',
  },
  [Steps.Attestation]: {
    title: 'Attestation de recensement',
    dataTestId: 'assistant-step-attestation',
  },
};

export default ASSISTANT_STEPS;
